module.exports = __webpack_public_path__ + "static/efficient-payment-8ef4f5d817a6283c41b2daaf3b15b686.png";